module.exports = __webpack_public_path__ + "img/masks/banner.svg";